import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetV2SitesQuery } from '@/redux/apis/codes-api';
import { DropdownPicker } from '../dropdown-picker';

export const DropdownSites: FC<
  Omit<
    ComponentProps<typeof DropdownPicker>,
    'data' | 'emptyLabel' | 'selectAllLabel' | 'control' | 'search'
  > & { filterCountries?: string[] }
> = (props) => {
  const { filterCountries, ...rest } = props;
  const { t } = useTranslation();
  const { data } = useGetV2SitesQuery();
  const sites = (data || [])
    // filter by country
    .filter(({ country }) =>
      filterCountries?.length ? filterCountries.includes(country) : true
    )
    // remove duplicates by name
    .filter(
      (site, index, arr) => arr.findIndex((s) => s.name === site.name) === index
    )
    // map to DropdownItem
    .map(({ name }) => ({
      value: name,
      text: name,
    }));

  return (
    <DropdownPicker
      {...rest}
      // selectAllLabel={t('label.allLocations')}
      emptyLabel={t('label.site')}
      data={sites}
      control="checkbox"
      search
      maxSelected={3}
    />
  );
};
